import language from "../languages";
import homeIcon from "../assets/img/menu/beranda.png";
import studentIcon from "../assets/img/menu/kesiswaan.png";
import curiculumIcon from "../assets/img/menu/kurikulum.png";
import financeIcon from "../assets/img/menu/penganggaran.png";
import administrationIcon from "../assets/img/menu/administrasi.png";
import settingIcon from "../assets/img/menu/pengaturan.png";

export const SIDEBAR__DASHBOARD_MENU = [
  {
    title: language.translate.SIDEBAR__HOME,
    iconImage: homeIcon,
    path: "/dashboard",
  },
  {
    title: language.translate.SIDEBAR__STUDENT,
    iconImage: studentIcon,
    path: "/dashboard/kesiswaan",
    permission: "kesiswaan",
    menu: [
      {
        title: "Penerimaan Siswa",
        icon: "icon-minus",
        path: "/dashboard/kesiswaan/penerimaan-siswa",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "penerimaan_siswa",
        menu: [
          {
            title: "Penerimaan Siswa Baru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/list-pendaftaran-ppdb",
            permission: "ppdb_offline",
          },
          {
            title: "Penerimaan Siswa Baru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/list-pendaftaran-ppdb",
            permission: "ppdb_offline_general",
          },
          {
            title: "Mutasi Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/list-pendaftaran-siswa",
            permission: "mutasi_siswa",
          },
        ],
      },
      {
        title: "Data Siswa",
        icon: "icon-minus",
        path: "/dashboard/kesiswaan/data-siswa",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "data_siswa",
        menu: [
          {
            title: "Daftar Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/daftar-siswa",
            permission: "daftar_siswa",
          },
          {
            title: "Jumlah Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/jumlah-siswa",
            permission: "jumlah_siswa",
          },
          {
            title: "Laporan PPDB Online",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/data-siswa/daftar-siswa-ppdb",
            permission: "laporan_ppdb",
          },
          {
            title: "Laporan PPDB Online",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/data-siswa/daftar-siswa-ppdb-general",
            permission: "laporan_ppdb_general",
          },
          {
            title: "Mutasi Keluar",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/data-siswa/mutasi-keluar",
            permission: "mutasi_keluar",
          },
          {
            title: "Pembatalan Mutasi Keluar",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/data-siswa/pembatalan-mutasi-keluar",
            permission: "pembatalan_mutasi_keluar",
          },
          {
            title: "Statistik Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/data-siswa/statistik-siswa",
            permission: "statistik_siswa",
          },
        ],
      },
      {
        title: "Presensi Siswa",
        icon: "icon-minus",
        path: "/dashboard/kesiswaan/absensi-siswa",
        className: "menu__left-icon--small",
        permission: "absensi_siswa",
        padding: 20,
        menu: [
          {
            title: "Presensi Harian",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/absensi-siswa/absensi-harian",
            permission: "absensi_harian",
          },
          {
            title: "Presensi per Mata Pelajaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/absensi-siswa/isi-perbidang-study",
            permission: "isi_perbidang_study",
          },
          {
            title: "Rekap Presensi ",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/absensi-siswa/absensi-rekap",
            permission: "absensi_rekap",
          },
          {
            title: "Laporan Absen Bidang Study",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/absensi-siswa/laporan-absen-bidang-study",
            permission: "laporan_absen_bidang_study",
          },
        ],
      },
      {
        title: "Disipliner",
        icon: "icon-minus",
        path: "/dashboard/kesiswaan/displiner",
        className: "menu__left-icon--small",
        permission: "disipliner",
        padding: 20,
        menu: [
          {
            title: "Tabel Pelanggaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/displiner/table-pelanggaran",
            permission: "tabel_pelanggaran",
          },
          {
            title: "Tabel Prestasi",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/displiner/table-prestasi",
            permission: "tabel_prestasi",
          },
          {
            title: "Catat Pelanggaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/displiner/catat-pelanggaran",
            permission: "catat_pelanggaran",
          },
          {
            title: "Catat Prestasi",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/displiner/catat-prestasi",
            permission: "catat_prestasi",
          },
          {
            title: "Catat Harian Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/displiner/catat-harian-siswa",
            permission: "catat_harian_siswa",
          },
        ],
      },
      {
        title: "Ekstrakurikuler",
        icon: "icon-minus",
        path: "/dashboard/kesiswaan/ekstrakulikuler",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "ekskul",
        menu: [
          {
            title: "Jenis Ekstrakulikuler",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/ekstrakulikuler/jenis-ekstrakulikuler",
            permission: "jenis_ekskul",
          },
          {
            title: "Daftar Peserta Ekskul",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/ekstrakulikuler/daftar-peserta-ekskul",
            permission: "daftar_peserta_ekskul",
          },
          {
            title: "Pembagian Kelas Ekskul",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/ekstrakulikuler/pembagian-kelas-ekskul",
            permission: "pembagian_kelas_ekskul",
          },
          {
            title: "Absensi Ekskul",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/ekstrakulikuler/absensi-ekskul",
            permission: "absensi_eksul",
          },
          {
            title: "Pengisian Nilai Ekskul",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/ekstrakulikuler/pengisian-nilai-ekskul",
            permission: "pengisian_nilai_ekskul",
          },
        ],
      },
      {
        title: "Bimbingan Konseling",
        path: "/dashboard/kesiswaan/bimbingan-konseling/konseling-siswa",
        icon: "icon-minus",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "bimbingan_konseling",
      },
      {
        title: language.translate.SIDEBAR__STUDENT__STUDENT_REPORT,
        icon: "icon-minus",
        className: "menu__left-icon--small",
        path: "/dashboard/kesiswaan/laporan",
        padding: 20,
        permission: "laporan_kesiswaan",
        menu: [
          {
            title: language.translate.SIDEBAR__STUDENT__STUDENT_REPORT__KLAPPER,
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/klapper",
            permission: "klapper",
          },
          {
            title: "Laporan 8355",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/laporan-8355",
            permission: "laporan_8355",
          },
          {
            title: "Laporan Displiner",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/laporan-displiner",
            permission: "laporan_displiner",
          },
          {
            title: "Laporan Konseling",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/laporan-konseling",
            permission: "laporan_konseling",
          },
          {
            title: "Laporan Absensi Kelas",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/laporan-absensi-kelas",
            permission: "laporan_absensi_kelas"
          },
          {
            title: "Laporan Persensi",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kesiswaan/laporan/laporan-persensi",
            permission: "laporan_persensi"
          },
        ],
      },
    ],
  },
  {
    // title: language.translate.SIDEBAR__ADMINISTRATION,
    title: "Tata Usaha",
    iconImage: administrationIcon,
    path: "/dashboard/tata-usaha",
    permission: "tata_usaha",
    menu: [
        
      {
        title: "Manajemen Kelas",
        icon: "icon-minus",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tata-usaha/manajemen-kelas",
        permission: "manajemen_kelas",
        menu: [
          //     {
          //     title: 'Identitas Unit Sekolah',
          //     icon: 'icon-angle-right',
          //     className: 'menu__left-icon--small',
          //     padding: 40,
          //     path: '/dashboard/tata-usaha/manajemen-kelas/identitas-unit-sekolah',

          // },
          // {
          //   title: "Tahun Ajaran Baru",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/tahun-ajaran",
          // },

          // {
          //   title: "Kelas",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/kelas",
          // },
          // {
          //   title: "Pembagian Kelas",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/pembagian-kelas",
          // },
          {
            title: "Kenaikan Kelas Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/tata-usaha/manajemen-kelas/kenaikan-kelas-siswa",
            permission: "kenaikan_kelas_siswa",
          },
          {
            title: "Pembagian Kelas PPDB",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/tata-usaha/manajemen-kelas/pembagian-kelas-ppdb",
            permission: "pembagian_kelas_ppdb",
          },
          {
            title: "Pengaturan Kelas Tahun Ajaran Baru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/tata-usaha/manajemen-kelas/pengaturan-kelas-ajaran-baru",
            permission: "laporan_kelas_tahun_ajaran_baru",
          },
          // {
          //   title: 'Kelas Khusus',
          //   icon: 'icon-angle-right',
          //   className: 'menu__left-icon--small',
          //   padding: 40,
          //   path: '/dashboard/tata-usaha/manajemen-kelas/kelas-khusus',

          // },
          // {
          //   title: 'Pembagian Kelas Khusus',
          //   icon: 'icon-angle-right',
          //   className: 'menu__left-icon--small',
          //   padding: 40,
          //   path: '/dashboard/tata-usaha/manajemen-kelas/pembagian-kelas-khusus',

          // },
          {
            title: "Siswa Pindah Kelas",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/tata-usaha/manajemen-kelas/siswa-pindah-kelas",
            permission: "siswa_pindah_kelas",
          },
          {
            title: "Pembatalan Siswa",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/tata-usaha/manajemen-kelas/pembatalan-siswa",
            permission: "pembatalan_siswa",
          },
          // {
          //   title: "Pindah Unit",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/pindah-unit",
          // },
          // {
          //   title: "Daftar Pindah Unit",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/daftar-pindah-unit",
          // },
          // {
          //   title: "Permohonan Pindah Unit",
          //   icon: "icon-angle-right",
          //   className: "menu__left-icon--small",
          //   padding: 40,
          //   path: "/dashboard/tata-usaha/manajemen-kelas/permohonan-pindah-unit",
          // },
        ],
        
      },
      {
        title: "Struktur Jabatan Unit",
        icon: "icon-minus",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/struktur-unit",
        permission: "struktur_unit",
      },
      {
        title: "Laporan Pegawai",
        icon: "icon-minus",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tata-usaha/laporan-pegawai",
        permission: "laporan_pegawai",
         menu: [
              {
              title: 'Laporan Jumlah Pegawai',
              icon: 'icon-angle-right',
              className: 'menu__left-icon--small',
              padding: 40,
              path: '/dashboard/tata-usaha/laporan-pegawai/laporan-jml-pegawai',
              permission: "laporan_jml_pegawai",


          },
              {
              title: 'Laporan Jenis Pekerjaan',
              icon: 'icon-angle-right',
              className: 'menu__left-icon--small',
              padding: 40,
              path: '/dashboard/tata-usaha/laporan-pegawai/laporan-jenis-pekerjaan',
              permission: "laporan_jenis_pegawai",

          },
              {
              title: 'Laporan Jumlah Jam Mengajar',
              icon: 'icon-angle-right',
              className: 'menu__left-icon--small',
              padding: 40,
              path: '/dashboard/tata-usaha/laporan-pegawai/laporan-jml-jp',
              permission: "laporan_jml_jp",

          },
              {
              title: 'Laporan Guru',
              icon: 'icon-angle-right',
              className: 'menu__left-icon--small',
              padding: 40,
              path: '/dashboard/tata-usaha/laporan-pegawai/laporan-guru',
              permission: "laporan_guru",

          },
         ]
      },
    ],
  },
      {
    title: language.translate.SIDEBAR__CURRICULUM,
    iconImage: curiculumIcon,
    path: "/dashboard/kurikulum",
    permission: "kurikulum",
    menu: [
      {
        title: "Pengumuman",
        icon: "icon-minus",
        path: "/dashboard/kurikulum/Pengumuman",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "pengumuman",
      },
      {
        title: "Jadwal Kelas & Karyawan",
        icon: "icon-minus",
        path: "/dashboard/kurikulum/jadwal/jadwal-per-kelas",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "jadwal_kelas_dan_guru",
      },
      
      {
        title: "Ulangan",
        icon: "icon-minus",
        path: "/dashboard/kurikulum/ulangan",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "ulangan",
        menu: [
          {
            title: "Pengisian Nilai",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/ulangan/pengisian-nilai-kognitif",
            permission: "pengisian_nilai",
          },
          {
            title: "Daftar Nilai",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/ulangan/daftar-nilai",
            permission: "daftar_nilai",
          },
        ],
      },
      {
        title: "Mata Pelajaran",
        icon: "icon-minus",
        path: "/dashboard/kurikulum/mata-pelajaran",
        className: "menu__left-icon--small",
        padding: 20,
        // permission: "mata_pelajaran",
        menu: [
          
          {
            title: "Parameter JP",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/parameter-jp",
            permission: "parameter_jp",
          },
          {
            title: "Daftar Guru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/mata-pelajaran/daftar-guru",
            permission: "daftar_guru",
          },
          {
            title: "Kode Guru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/mata-pelajaran/kode-guru",
            permission: "kode_guru",
          },
               {
            title: "Mata Pelajaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/pengaturan/data-mapel-unit",
            permission: "mapel_per_unit",
     },
    
    //  {
    //     title: "Jadwal Pelajaran",
    //     icon: "icon-minus",
    //     path: "/dashboard/kurikulum/jadwal-pelajaran",
    //     className: "menu__left-icon--small",
    //     padding: 20,
    //     permission: "jadwal_pelajaran",
    //     menu: [
          {
            title: "Jadwal Mata Pelajaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/pengaturan/data-jadwal-matpel",
            permission: "data_jadwal_matpel",
          },
           {
            title: "Jadwal Mapel Guru",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/mata-pelajaran/jadwal-mapel-guru",
            permission: "jadwal_mapel_guru",
          },
           {
            title: "Laporan Wajib Mengajar",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/laporan-jp",
            permission: "laporan_jp",
          },
          {
            title: "Laporan Mata Pelajaran",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/laporan-mapel",
            permission: "laporan_mapel",
          },
         
          {
            title: "Rekapitulasi Jadwal",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/rekapitulasi-jadwal",
            permission: "rekapitulasi_jadwal",
          },
        // ],
        // },
        ],
      },
      
      {
        title: "Raport",
        icon: "icon-minus",
        path: "/dashboard/kurikulum/raport",
        className: "menu__left-icon--small",
        padding: 20,
        permission: "raport",
        menu: [
          {
            title: "Daftar Nilai Raport",
            icon: "icon-angle-right",
            className: "menu__left-icon--small",
            padding: 40,
            path: "/dashboard/kurikulum/raport/daftar-nilai-raport",
            permission: "daftar_nilai_raport",
          },
         
        ],
      },
      
    ],
  },
 
  {
    title: "Keuangan Siswa",
    className: "menu__left-icon--small",
    path: "/dashboard/tagihan-siswa",
    iconImage: financeIcon,
    permission: "tagihan_siswa",
    menu: [
      //   {
      //     title: "Nama Pembayaran",
      //     icon: "icon-angle-right",
      //     className: "menu__left-icon--small",
      //     padding: 20,
      //     path: "/dashboard/tagihan-siswa/nama-pembayaran",
      //     permission: "nama_pembayaran"
      //   },
      {
        title: "Buat Invoice",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/create-invoice",
        permission: "buat_invoice",
      },
      {
        title: "Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/pembayaran",
        permission: "pembayaran",
      },
      {
        title: "Edit Tagihan Kelas",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-pembayaran",
        permission: "edit_tagihan",
      },
      {
        title: "Edit Tagihan Siswa",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/edit-tagihan-siswa",
        permission: "edit_tagihan_siswa",
      },
      {
        title: "Riwayat Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/riwayat",
        permission: "riwayat_pembayaran",
      },
      {
        title: "Rincian Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/rincian-pembayaran",
        permission: "rincian_pembayaran",
      },
      {
        title: "Siswa Batal Masuk",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/siswa-batal-masuk",
        permission: "siswa_batal_masuk",
      },
      {
        title: "Laporan Bantuan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-bantuan",
        permission: "laporan_bantuan",
      },
      {
        title: "Laporan Uang Pendaftaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-uang-pendaftaran",
        permission: "laporan_uang_pendaftaran",
      },
      {
        title: "Laporan Pembayaran PPDB",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-pembayaran-ppdb",
        permission: "laporan_pembayaran_ppdb",
      },
      {
        title: "Laporan Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-pembayaran-total",
        permission: "laporan_pembayaran",
      },
      {
        title: "Laporan Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-pembayaran-total-general",
        permission: "laporan_pembayaran_general",
      },
      {
        title: "Laporan Piutang Bulanan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-piutang-bulanan",
        permission: "laporan_piutang_bulanan",
      },
      {
        title: "Rekap Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/rekap-pembayaran",
        permission: "rekap_pembayaran",
      },
      {
        title: "Kartu Pembayaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/kartu-bayar-siswa",
        permission: "kartu_bayar",
      },
      {
        title: "Tunggakan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/tunggakan",
        permission: "tunggakan",
      },
      {
        title: "Tunggakan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/tunggakan-general",
        permission: "tunggakan_general",
      },
      {
        title: "Rekap Penyesuaian",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/rekap-penyesuaian",
        permission: "rekap_penyesuaian",
      },
      {
        title: "Laporan Keuangan Siswa",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/laporan-keuangan-siswa",
        permission: "laporan_keuangan_siswa",
      },
      {
        title: "Piutang Siswa",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/tagihan-siswa/piutang-siswa",
        permission: "piutang_siswa",
      },
    ],
  },
  {
    title: language.translate.SIDEBAR__SETTING,
    iconImage: settingIcon,
    path: "/dashboard/pengaturan",
    menu: [
       {
        title: "Uang Pendaftaran PPDB",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/uang-pendaftaran-ppdb",
        permission: "uang_pendaftaran_ppdb",
      },
      {
        title: "Ganti Kata Sandi",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/ganti-kata-sandi",
        permission: "ganti_kata_sandi",
      },
      {
        title: "Atur Ulang Kata Sandi",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/atur-ulang-kata-sandi",
        permission: "atur_ulang_kata_sandi",
      },
      {
        title: "Blok Unit",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/blok-unit",
        permission: "blok_unit",
      },
     
      {
        title: "Identitas Unit Sekolah",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/identitas-unit-sekolah",
        permission: "identitas_unit_sekolah",
      },
      {
        title: "Tahun Ajaran Baru",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/tahun-ajaran",
        permission: "tahun_ajaran_baru",
      },
      {
        title: "Data Guru",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/data-guru",
        permission: "data_guru",
      },
      {
        title: "Data Mata Pelajaran",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/data-mata-pelajaran",
        permission: "data_mata_pelajaran",
      },
      {
        title: "Master Mapel",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/master-mapel",
        permission: "master_mapel",
      },
      {
        title: "Jurusan Kelas",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/jurusan-kelas",
        permission: "jurusan_kelas",
      },
      {
        title: "Pembentukan Kelas",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/kelas",
        permission: "pembentukan_kelas",
      },
      {
        title: "Import Daftar Siswa",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/import-daftar-siswa",
        permission: "import_daftar_siswa",
      },
      {
        title: "Import Siswa Unit",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/import-siswa-unit",
        permission: "import_siswa_unit",
      },
      {
        title: "Pengaturan Jam Mengajar",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/jam-mengajar",
        permission: "jam_mengajar",
      },
      {
        title: "Pengaturan Guru BK",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/parameter-bk",
        permission: "parameter_bk",
      },
      {
        title: "Pengaturan Jabatan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/jabatan",
        permission: "jabatan",
      },
      {
        title: "Pengaturan Jabatan Tambahan",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/struktur-unit-pusat",
        permission: "struktur_unit_pusat",
      },
      {
        title: "Pengaturan Rombel",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/rombel",
        permission: "pengaturan_rombel",
      },
      {
        title: "Pengaturan Tanggal Struktural",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/tanggal-struktural",
        permission: "pengaturan_rombel",
      },
      {
        title: "Unposting TK SD",
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 20,
        path: "/dashboard/pengaturan/unposting-tksd",
        permission: "unposting_tksd",
      },
     ],
    },
    ];

export const SIDEBAR_ADMISSION_MENU = [
  {
    title: language.translate.SIDEBAR__HOME,
    iconImage: homeIcon,
    path: "/admission",
    menu: [
      {
        title: language.translate.SIDEBAR__FINANCE__REPORT__BALANCE,
        icon: "icon-angle-right",
        className: "menu__left-icon--small",
        padding: 40,
        path: "/dashboard/keuangan/laporan/neraca",
      },
      {},
    ],
  },
];
